"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODAL_CONSTANTS = {
  TITLE: 'Choose Most or Least',
  CONTENT: 'You’re about to do something very unique. It’s not about the kind of grades you get or what you like to do – it’s about your Authentic Abilities. Don’t overthink it! There are no right or wrong answers, as long as your choices are true for you – not how others view you. Most of the time your first impulse is the one you should go with. There are two responses for each block – Most and Least. Select “Most” for the phrase that MOST fits you, and “Least” for the phrase that is LEAST fits you.'
};